export class CoBuyerModel {
    public IsAllowUserToAddEditCoBuyerPermission: boolean=false;
    public CoBuyerlstData: ContractCOBuyer[] = [];

}
export class ContractCOBuyer{
    public ContractCOBuyerID: number;
    public CoBuyerID : number;
    public BuyerID: number;
    public CoBuyerName:string;
    public IsCoBuyer: boolean;
    public UserId: number;
}


export class CoBuyerInfoModel  {
    public CoBuyerID: number=0;
    public BuyerID: number;
    public  Title: string;
    public FirstName: string;
    public  MiddleName: string;
    public  LastName: string;
    public  Phone: string;
    public EmailAddress: string;
    public Suffix: string;
    public Address1: string;
    public Address2: string;
    public CityID: number;
    public StateId: number;
    public  CountryId: number;
    public ZipCode: string;
    public CreatedUserID: number;
    public CreatedDate: string;
    public ModifiedUserID: number;
    public ModifiedDate: string;
    public IsCall: boolean=false;
    public IsText: boolean=false;
    public IsEmail: boolean=false;
    public CommunityLotID: number;
    public ContractID: number;
    public City: string;
    public State: string;
    public CreatedFrom: string='BW';
    public UserId: number;
    public PrimaryStateName : string;
    public PrimaryCityName:string;
    public CopyFromCoBuyerID:number=0;
    
}



// WEBPACK FOOTER //
// ./src/app/models/CoBuyerModel.ts